import { Flag, Shield, UserCheck } from "lucide-react";

import { SessionAnalysis } from "../../../../../types/supabase";

interface RiskMonitorProps {
  analysis: SessionAnalysis;
}

export const RiskMonitor = ({ analysis }: RiskMonitorProps) => {
  const isAlert =
    analysis?.content?.alert &&
    analysis?.content?.alert.toLowerCase() !== "none";
  const color = isAlert ? "red" : "green";
  const content = isAlert ? analysis?.content?.alert : "No alerts, all good!";

  return (
    <section className="bg-white rounded-xl p-6 shadow-sm">
      <h2 className="text-xl font-semibold mb-6 flex items-center">
        <Shield className="w-5 h-5 mr-2 text-green-600" />
        Risk & Ethics Monitoring
      </h2>
      <div className="space-y-4">
        {analysis?.content?.stressors && (
          <div className="p-4 bg-red-100 rounded-lg">
            <div className="flex items-center mb-2">
              <Flag className="w-4 h-4 text-red-600 mr-2" />
              <h3 className="font-medium text-black-900">Flagged Keywords</h3>
            </div>
            <p className="text-sm text-black-800">
              Detected: {analysis?.content?.stressors.join(", ")}
            </p>
          </div>
        )}
        <div className={`p-4 bg-${color}-100 rounded-lg`}>
          <div className="flex items-center mb-2">
            <UserCheck className={`w-4 h-4 text-${color}-600 mr-2`} />
            <h3 className={`font-medium text-black-900`}>Alerts</h3>
          </div>
          <p className="text-sm text-black-800">{content}</p>
        </div>
      </div>
    </section>
  );
};
